// NEW ALL NEW WITH STORING CHECKED IN A VARIABLE-
import React, { useMemo, useRef, useCallback, useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import Spinner from "../../common/Spinner/Spinner";

const RelatedPartnerNames = ({tableData, loading, selectedPendingPartnerName}) => {
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%", backgroundColor:"" }), []);

    // const handleCheckboxChange = useCallback((event, data) => {
    //     setCheckedEntryPoints((prev) => {
    //         if (event.target.checked) {
    //             return [...prev, data];
    //         } else {
    //             return prev.filter((entry) => entry.Id !== data.Id);
    //         }
    //     });
    // }, []);

    // const handlePendingPartnerSelect = async(event, data) => {
    //     console.log(data, ">>>>data") ;
        
    //     if(selectedPendingPartnerName.length>0){
    //         let existingSelected = selectedPendingPartnerName[0];
    //         if(existingSelected.Id === data.Id){
    //             setSelectedPendingPartnerName([])
    //         }else{
    //             setSelectedPendingPartnerName([data]) 
    //         }
    //     }else{
    //         setSelectedPendingPartnerName([data])  
    //     }
    // }

    const columnDefs = [
        // {
        //     headerName: "Select",
        //     field: "select",
        //     width: 100,
        //     cellRenderer: (params) => {
        //         return (
        //             <input
        //                 type="checkbox"
        //                 checked={checkedEntryPoints.some((entry) => entry.Id === params.data.Id)}
        //                 onChange={(event) => handleCheckboxChange(event, params.data)}
        //                 disabled={isAddClicked}
        //             />
        //         );
        //     },
        // },
        {
            headerName: "Sr No.",
            valueGetter: (params) => params.node.rowIndex + 1,
            width: 100,
        },
        {
            headerName: "Related Partner Name('s)",
            // field: "sEntryPoint",
            flex: 1,
            cellRenderer: (params) => {
                return(
                    <p>{params.data.sEntryPoint}</p>
                )
            }
        },
        // {
        //     headerName: "Validation Status",
        //     field: "valdiation status",
        //     width: 170,
        // },
    ];

    console.log(tableData, ">>>tableData");
    return (
        <div className={`${loading && "set-opacity"}`}>
            <div style={{ height: `${selectedPendingPartnerName.length>0 ? "58vh": ""}`, backgroundColor:"" }}>
                <div style={{ height: "100%", boxSizing: "border-box" }}>
                    <div style={gridStyle} className="ag-theme-material">
                        {loading && <Spinner className="center" />}
                        <AgGridReact
                            ref={gridRef}
                            rowData={tableData || []}
                            columnDefs={columnDefs}
                            pagination={true}
                            paginationPageSize={20}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RelatedPartnerNames;